import { TypeHelper } from "@iconics/core";
import { ODataSelect } from "@iconics/core";

export class Solution extends ODataSelect
{
    public Id = '';
    public Name = '';
    public Description = '';
    public ImageUri: string | null = '';
    public ApplicationUri = '';
    public IsEnabled = false;

    public init(response: any, nodeId: number): Solution
    {
        Object.assign(this, response);
        this.IsEnabled = TypeHelper.toBoolean(response.IsEnabled) ?? false;
        return this;
    }

    public toSelect(): string
    {
        return 'ID,Name,Description,ImageUri,ApplicationUri,IsEnabled';
    }
}
